/**
 * Copyright IBM Corp. 2022, 2026
 */

import { Link } from 'lib/i18n/routing'
import s from './tags.module.css'

export default function Tags({ tags }) {
	if (tags?.length > 0) {
		return (
			<div>
				{/* in the designs, the items are actually "event types", which seem to equal "categories", not tags*/}
				<h4 className="g-type-display-4">Tagged</h4>
				<div className={s.tags}>
					{tags.map((tag) => (
						<Link key={tag.slug} href={`/events/tag/${tag.slug}`}>
							{tag.name}
						</Link>
					))}
				</div>
			</div>
		)
	}
	return null
}
